import React from 'react';
// import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
// import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
// import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
// import IconButton from '@material-ui/core/IconButton';
// import ButtonGroup from '@material-ui/core/ButtonGroup';
// import Button from '@material-ui/core/Button';

// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
// import { getCalendarFirstDay, createMonthlyCalendarData } from '../../common/calendarHelper';
// import { CALENDAR_TYPE_MONTH, CALENDAR_TYPE_WEEK } from '../../common/constants';
import AfitdTypography from '../../common/elemental/AfitdTypography';
// import Week from './Week';

// import cx from 'clsx';
// import { format } from 'date-fns';
// import startOfMonth from 'date-fns/startOfMonth';
// import subMonths from 'date-fns/subMonths';
// import addMonths from 'date-fns/addMonths';
// import getMonth from 'date-fns/getMonth';
// import _range from 'lodash/range';
// import _get from 'lodash/get';
// import _set from 'lodash/set';
// import _forEach from 'lodash/forEach';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        margin: '0 0 16px 5px',
    },
    //chatRightBlock2In h6
    messagesNewText: {
        letterSpacing: 0,
        color: '#fd811f',
    },
});

const getDefns = params => {
    const { props } = params;
    const { classes, unreadMessagesCount } = props;

    const defns = {
        messagesNewText: {
            variant: 'caption',
            clsLightBold: true,
            value: `${unreadMessagesCount} NEW MESSAGE${unreadMessagesCount > 1 ? 'S' : ''}`,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const MessagesDate = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { newMessageSignRef } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <div {...defns.root} ref={newMessageSignRef}>
            <AfitdTypography {...defns.messagesNewText} />
        </div>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(MessagesDate);
